/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Swal from "sweetalert2";
import Moneda from "../../../components/Presupuesto/Moneda";
import {
  FechaPartidaAdd,
  FechaPartidaDelete,
  FechasPartidaGet,
} from "../../../service/partidaDetalle";
import "./ModalDetalle.css";

const MESES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

/** "2024-04-29" -> "29 de abril de 2024". */
const enPalabras = (fecha) => {
  if (!fecha) return "";

  const [anio, mes, dia] = String(fecha).slice(0, 10).split("-");

  return `${Number(dia)} de ${MESES[Number(mes) - 1]} de ${anio}`;
};

/**
 * Fechas de pago de una partida.
 *
 * Aquí se programan los pagos y se ve lo que ya está programado contra lo que
 * cuesta la partida. Antes esta pantalla sólo listaba, sin forma de agregar
 * ninguna fecha.
 */
export default function ModalFecha({ ModalFecha: abierto, toggleFecha, IDFecha, token }) {
  const [fechas, setFechas] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [fecha, setFecha] = useState("");
  const [monto, setMonto] = useState("");
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(() => {
    if (!IDFecha) return;

    setCargando(true);
    FechasPartidaGet(IDFecha, token)
      .then((respuesta) => setFechas(respuesta?.fechas ?? []))
      .catch(() => setFechas([]))
      .finally(() => setCargando(false));
  }, [IDFecha, token]);

  useEffect(() => {
    if (abierto) cargar();
  }, [abierto, cargar]);

  const programado = fechas.reduce((suma, f) => suma + (Number(f.monto) || 0), 0);

  const agregar = async (evento) => {
    evento.preventDefault();

    setGuardando(true);
    try {
      const respuesta = await FechaPartidaAdd(
        { hijos_id: IDFecha, fecha, monto },
        token
      );

      if (!respuesta?.guardado) {
        throw new Error(respuesta?.message || "No se pudo guardar la fecha");
      }

      setFecha("");
      setMonto("");
      cargar();
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: error.message });
    } finally {
      setGuardando(false);
    }
  };

  const borrar = async (id) => {
    const confirmacion = await Swal.fire({
      icon: "warning",
      title: "¿Quitar esta fecha de pago?",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#a81818",
    });

    if (!confirmacion.isConfirmed) return;

    await FechaPartidaDelete(id, token);
    cargar();
  };

  return (
    <Modal
      isOpen={abierto}
      toggle={toggleFecha}
      size="lg"
      className="modal-lci"
      contentClassName="modal-lci-contenido"
    >
      <ModalHeader toggle={toggleFecha}>
        <span className="modal-lci-titulo">Fechas de pago</span>
        <span className="modal-lci-sub">
          Programado: <Moneda valor={programado} />
        </span>
      </ModalHeader>
      <ModalBody>
        <form className="detalle-form" onSubmit={agregar}>
          <div className="detalle-campo">
            <label htmlFor="fecha-pago">Fecha</label>
            <input
              id="fecha-pago"
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
              required
            />
          </div>
          <div className="detalle-campo">
            <label htmlFor="fecha-monto">Monto</label>
            <input
              id="fecha-monto"
              type="number"
              step="any"
              min="0"
              value={monto}
              onChange={(e) => setMonto(e.target.value)}
              placeholder="0.00"
              required
            />
          </div>
          <button type="submit" className="crud-add-btn" disabled={guardando}>
            {guardando ? (
              <span className="spinner-boton" aria-hidden="true" />
            ) : (
              <i className="bi bi-plus-lg" aria-hidden="true"></i>
            )}
            Agregar fecha
          </button>
        </form>

        <div className="dtable-scroll">
          <table className="dtable">
            <thead>
              <tr>
                <th>Fecha</th>
                <th className="text-end">Monto</th>
                <th>Estado</th>
                <th className="text-center">Quitar</th>
              </tr>
            </thead>
            <tbody>
              {cargando && (
                <tr>
                  <td colSpan={4} className="dtable-empty">
                    Cargando las fechas...
                  </td>
                </tr>
              )}

              {!cargando && fechas.length === 0 && (
                <tr>
                  <td colSpan={4} className="dtable-empty">
                    Esta partida todavía no tiene fechas de pago.
                  </td>
                </tr>
              )}

              {!cargando &&
                fechas.map((f) => (
                  <tr key={f.id}>
                    <td>{enPalabras(f.fecha)}</td>
                    <td className="text-end">
                      <Moneda valor={f.monto} />
                    </td>
                    <td>
                      <span
                        className={`detalle-estado ${
                          f.status === "Pagado" ? "es-pagado" : "es-pendiente"
                        }`}
                      >
                        {f.status}
                      </span>
                    </td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        title="Quitar la fecha"
                        onClick={() => borrar(f.id)}
                      >
                        <i className="mdi mdi-delete-forever"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ModalBody>
    </Modal>
  );
}
